import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { qpRequiredMisc, qpLayoutControls } from "../../utils/misc";
import { connect } from 'react-redux';
import { actionCreators } from '../../store/AccountStore';
import { bindActionCreators } from 'redux';
import "./SideBar.css";

class SidebarHorizontal extends Component {
    componentDidMount() {
        this.props.getUser().then(result => {
            if (result) {
                this.setState({
                    email: result.email,
                    name: result.name
                })
            }
        })
        qpRequiredMisc();

        /* Demo Only */
        qpLayoutControls();
    }
    constructor(props) {
        super(props);
        this.state = { email: null, name: null, toggleMenu: '', showToggleMenu: false };
    }
    handleToggleMenu(value) {
        console.log('handleToggleMenu', value)
        if (value) {
            this.setState({
                toggleMenu: 'active',
                showToggleMenu: value
            })
            this.props.handleToggle(value)
        }
        else {
            this.setState({
                toggleMenu: '',
                showToggleMenu: value
            })
            this.props.handleToggle(value)
        }

    }
    handleToggleShowRender() {
        return (
            <nav className="sidebar-horizontal navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
                <div className="navbar-collapse" id="navbar-header-menu-outer">
                    <ul className="navbar-nav navbar-header-menu mr-auto">
                        <li className="nav-item">
                            <NavLink
                                exact
                                activeClassName="active"
                                className="nav-link"
                                to="/deliveryorder"
                            >
                                <div onClick={() => this.handleToggleMenu(this.state.showToggleMenu)}>
                                    <i className="batch-icon batch-icon-timeline" />
                                    SHIPMENTS
                                </div>
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink
                                exact
                                activeClassName="active"
                                className="nav-link"
                                to="/accounting"
                            >

                                <div onClick={() => this.handleToggleMenu(this.state.showToggleMenu)}>
                                    <i className="batch-icon batch-icon-paragraph-alt-justify" />
                                    Accounting
                                </div>
                            </NavLink>
                        </li>
                        {
                            this.state.userType === "FactoringContact" || this.state.userType === "Broker" ? null :<li className="nav-item">
                                <NavLink
                                    exact
                                    activeClassName="active"
                                    className="nav-link"
                                    to="/mycards"
                                >

                                    <div onClick={() => this.handleToggleMenu(this.state.showToggleMenu)}>
                                        <i className="batch-icon batch-icon-paragraph-alt-justify" />
                                        My Cards
                                </div>
                                </NavLink>
                            </li>
                        }
                        <li className="nav-item">
                            <NavLink
                                exact
                                activeClassName="active"
                                className="nav-link"
                                to="/Profile"
                            >
                                <div onClick={() => this.handleToggleMenu(this.state.showToggleMenu)}>
                                    <i className="batch-icon batch-icon-user" />
                                    Profile
                                </div>
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink exact activeClassName="active" to="/login" className="nav-link"><i className="batch-icon batch-icon-power" />Logout</NavLink>

                        </li>
                    </ul>

                </div>
            </nav>)
    }
    render() {
        if (this.props.toggleMenu || this.props.toggleMenu === undefined) {
            return (
                this.handleToggleShowRender()
            );
        }
        else {
            return (
                <nav className="sidebar-horizontal">
                    <div></div>
                </nav>
                )
        }
     
    }
}


export default connect(
    state => state.account,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(SidebarHorizontal);



// WEBPACK FOOTER //
// ./src/layout/SideBar/SidebarHorizontal.jsx